__turbopack_context__.v({
  "bingoTileFavorite": "styles-module-scss-module__YsSsGW__bingoTileFavorite",
  "bingoTileFavorite3D": "styles-module-scss-module__YsSsGW__bingoTileFavorite3D",
  "dark": "styles-module-scss-module__YsSsGW__dark",
  "dialogFavorite": "styles-module-scss-module__YsSsGW__dialogFavorite",
  "favoriteButton": "styles-module-scss-module__YsSsGW__favoriteButton",
  "filledHeart": "styles-module-scss-module__YsSsGW__filledHeart",
  "gamePlayFooter": "styles-module-scss-module__YsSsGW__gamePlayFooter",
  "gamePlayMobileHeader": "styles-module-scss-module__YsSsGW__gamePlayMobileHeader",
  "gamePlayVerticalHeader": "styles-module-scss-module__YsSsGW__gamePlayVerticalHeader",
  "snackbarMessage": "styles-module-scss-module__YsSsGW__snackbarMessage",
  "tileFavorite": "styles-module-scss-module__YsSsGW__tileFavorite",
  "topLeftContainerWithRadius": "styles-module-scss-module__YsSsGW__topLeftContainerWithRadius",
});
